import * as React from 'react'
import { cn } from '@/lib/utils'

// Loading placeholder — DESIGN.md: motion communicates state, never decorates.
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />
}
